/**
 * 表示状態
 */
export enum WprControlVisibility {
	/** 表示 */
	VISIBLE		= 1,
	/** 非表示 */
	HIDDEN		= 2,
	/** 領域確保 */
	COLLAPSED	= 3
}

/**
 * コントロールステータス情報
 */
export interface IWprControlState {
	value?: any;							// 値
	disabled?: boolean;						// 非活性状態
	readOnly?: boolean;						// 読取り専用
	visibility?: WprControlVisibility;		// 表示状態
	style?: any;							// スタイル
	className?: any;						// クラス
	hissu?: boolean;						// 必須
	min?: number | string;					// 最小値
	max?: number | string;					// 最大値
	minLength?: number;						// 最小長
	maxLength?: number;						// 最大長
	dirty?: boolean;						// 変更フラグ
	invalid?: boolean;						// バリデーションエラー
	option?: any;							// オプション（拡張）
	placeholder?: string;					// placeholder
}